import ptPlusApiBaseUrl from '../../../api/ptPlusApiBaseUrl';
import { UPDATE_DATA } from 'redux/actions/action_types'
import { showAppLoader, hideAppLoader } from '../app';

export const ptPlusAdminOrderRequestsList = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`/ptms/order/admin/order_list`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    return ex;
  });
};

export const ptPlusExportAdminOrderRequestsList = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl.post(`/ptms/order/admin/export/order_list`, data, {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};



export const adminFetchLocationListApi = (id, token) => (dispatch) => {
  return ptPlusApiBaseUrl.get('/ptms/internal/location_name_list', {
    headers: {
      Authorization: token,
      UserType: 'internal'
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const invoiceTableRecords = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl
    .post("/ptms/order/invoices", data, {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      dispatch({ type: UPDATE_DATA, payload: response.data, apiType: "form" });
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const invoiceStausUpdateApiFunc = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return ptPlusApiBaseUrl
    .post(`/ptms/order/invoice/update_status`, data, {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
    })
    .then((response) => {
      dispatch(hideAppLoader());
      return { error: false, data: response.data };
    })
    .catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};
export const sepctFileDownload = (token, invoiceId) => (dispatch) => {
  return ptPlusApiBaseUrl.get("/ptms/s3/get_file/" + invoiceId,
    {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
      responseType: "blob",
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      if (typeof ex === "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};
export const invoiceDownload = (token, invoiceId) => (dispatch) => {
  return ptPlusApiBaseUrl.get("/ptms/s3/get_file/" + invoiceId + ".pdf",
    {
      headers: {
        Authorization: `${token}`,
        UserType: "internal",
      },
      responseType: "blob",
    })
    .then((response) => {
      dispatch({ type: UPDATE_DATA, payload: response.data });
      return response.data;
    })
    .catch((ex) => {
      if (typeof ex === "string") {
        return { ex: { message: ex } };
      }
      return { error: true, data: ex.response?.data };
    });
};